import { useEffect, useState } from 'react';
import Navigation from './Navigation';

export default function Hero() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/49ae41b214a75cb54f9240802fe43db1.jpg"
          alt="イベント会場の賑やかな雰囲気"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-emerald-900/40 via-emerald-800/30 to-emerald-900/40"></div>
      </div>

      {/* Navigation */}
      <Navigation isScrolled={isScrolled} />

      {/* Main Content */}
      <div className="relative z-10 h-full flex items-center">
        <div className="w-full max-w-7xl mx-auto px-20">
          <div className="max-w-2xl">
            <h2 className="text-white font-black text-7xl leading-tight mb-16" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              心に残る瞬間を<br />
              共に創り上げる
            </h2>
            <button
              onClick={() => scrollToSection('services')}
              className="group flex items-center gap-4 bg-[#FF8B6A]/90 hover:bg-[#FF8B6A] text-white px-8 py-4 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <span className="text-base font-medium">詳しく見る</span>
              <div className="w-8 h-8 flex items-center justify-center bg-white rounded-full">
                <i className="ri-arrow-right-line text-[#FF8B6A] text-lg"></i>
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* Bottom Decoration */}
      <div className="absolute bottom-24 left-0 right-0 z-0 overflow-hidden pointer-events-none">
        <div className="text-white/10 font-black text-[180px] tracking-wider" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
          OHISAMA
        </div>
      </div>
    </section>
  );
}